import { render, staticRenderFns } from "./ques31.vue?vue&type=template&id=36372328&scoped=true"
import script from "./ques31.vue?vue&type=script&lang=js"
export * from "./ques31.vue?vue&type=script&lang=js"
import style0 from "./ques31.vue?vue&type=style&index=0&id=36372328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36372328",
  null
  
)

export default component.exports